import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { TwitterTimelineEmbed } from 'react-twitter-embed';
import styles from './feed.module.scss';
import Clickable from '../../../components/clickable/Clickable';

const Feed =({ links }) => {
  const [activeTab, setActiveTab] = useState('facebook');
  const [fbHeight, setFbHeight] = useState(0);
  const [fbWidth, setFbWidth] = useState(0);
  const mainContentRef = useRef(null);
  const offsetHeight = mainContentRef?.current?.offsetHeight;
  const offsetWidth = mainContentRef?.current?.offsetWidth;

  useEffect(() => {
    const element = mainContentRef.current;
    if (element) {
      const height = element.offsetHeight;
      const width = element.offsetWidth;
      setFbHeight(height - 90);
      setFbWidth(width - 40);
    }
  }, [offsetHeight, offsetWidth]);

  useEffect(() => {
    if (window.FB) {
      window.FB.XFBML.parse();
    }
  }, [activeTab, fbHeight, fbWidth]);

  return (
    <div style={{ height: '100%' }} ref={mainContentRef}>
      { links && (links.facebook || links.twitter)
        ? (
          <div className={styles.feed}>
            <div className={styles.navigation}>
              { links && links.facebook
              && (
              <Clickable className={activeTab === 'facebook' ? styles.active:''} onClick={() => {
                setActiveTab('facebook');
              }}
              >
                <FormattedMessage id="feed.facebook" defaultMessage="Facebook" />
              </Clickable>
              )
}
              { links && links.twitter
              && (
              <Clickable style={{ borderBottom: '#fff', color: '#8C9EA7' }} className={!(activeTab === 'twitter') ? styles.active:''} onClick={() => {
                  const twitter = (links?.twitter || '')?.trim();
                  let link = 'https://x.com/';

                  if (twitter) {
                    link = twitter.startsWith('http')
                      ? twitter.replace('twitter.com', 'x.com')
                      : `https://x.com/${twitter}`;
                  }

                  window.open(link, '_blank');
                }}>
                <FormattedMessage id="feed.twitter" defaultMessage="X" />
              </Clickable>
              )
              }
            </div>
            <div className={styles.mainContent}>
              {links && links.facebook && activeTab === 'facebook'
                    && (
                    <div className="fb-page"
                      data-href={links.facebook}
                      data-tabs="timeline"
                      data-height={fbHeight}
                      data-width={fbWidth}
                      data-small-header="true"
                      data-adapt-container-width="true"
                      data-hide-cover="true"
                      data-show-facepile="true"
                    />
                    )
                }
              { links && links.twitter && activeTab === 'twitter'
                  && (
                  <TwitterTimelineEmbed
                    sourceType="profile"
                    screenName={links.twitter}
                    options={{ height: 700, width: 400 }}
                  />
                  )
                }
            </div>
          </div>
        )
        : ''
}
    </div>
  );
};

export default (Feed);
